import {DashboardCard, Loading} from '@hm/fundamental'
import {useGetHeatZoneNames} from '@kilnfeature/api/queries/useGetHeatZoneNames'

import {
  useRefractoryClassificationsQuery,
  useRefraManufacturersQuery
} from '../common/hooks/queries'

import {FiltersPanel, FiltersProvider} from './components/Filters'
import {Report} from './components/Report'

import {getAllKilns} from '@refra/modules/refra-flexible-report/helpers'
import {
  useGetAssetConfigQuery,
  useUpmGlobalStructureQuery
} from '@refra/modules/refra-flexible-report/hooks/queries'
import {UpmFilter} from '@refra/modules/refra-flexible-report/types'

const DEFAULT_UPM_FILTERS: UpmFilter[] = [
  {level: 'ManagementArea'},
  {level: 'Country'},
  {level: 'Plant'},
  {level: 'Department', onlyTypeIds: ['901e1d00-d7a5-42c7-93f3-410537b3f7b5']}
]

export const RefraFlexibleReport = () => {
  const {data: upmHierarchyData} = useUpmGlobalStructureQuery(DEFAULT_UPM_FILTERS)
  const allKilns = upmHierarchyData ? getAllKilns(upmHierarchyData.hierarchy ?? []) : []
  const {data: assetConfigData} = useGetAssetConfigQuery(
    'Department',
    ['calciner', 'separator', 'preheater'],
    allKilns,
    allKilns?.length > 0
  )
  const {data: refraManufacturersData} = useRefraManufacturersQuery()
  const {data: refractoryClassificationsData} = useRefractoryClassificationsQuery()
  const {data: heatZones} = useGetHeatZoneNames()

  if (!upmHierarchyData || !assetConfigData || !refraManufacturersData) {
    return <Loading size="xlarge" data-cy="refra_flexible_report_loader" />
  }

  return (
    <FiltersProvider
      upmHierarchyData={upmHierarchyData}
      assetConfigData={assetConfigData}
      refraManufacturersData={refraManufacturersData}
      refractoryClassificationsData={refractoryClassificationsData}
      heatZones={heatZones}
    >
      <div className="grid grid-cols-[520px_minmax(0,1fr)] gap-4 p-4">
        <DashboardCard>
          <FiltersPanel />
        </DashboardCard>
        <DashboardCard className="min-w-0">
          <Report />
        </DashboardCard>
      </div>
    </FiltersProvider>
  )
}
